import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DoExamPaper from '@/components/exam/DoExamPaper.vue';
import ChartsPage from '@/components/exam/ChartsPage.vue';
import html2canvas from "html2canvas";
import $ from 'jquery';
export default {
  data: function data() {
    return {
      ifLoad: false,
      loadingImage: false,
      reportType: 1,
      studentExamPaperInfo: {},
      name: '程 , 凯楠',
      gender: 'M',
      informationAboutScoresInfo: [{
        name: "Sections",
        text: "Scaled Scores",
        id: "1"
      }, {
        name: "Reading",
        text: "0-30",
        id: "2"
      }, {
        name: "Listening",
        text: "0-30",
        id: "3"
      }, {
        name: "Speaking",
        text: "0-30",
        id: "4"
      }, {
        name: "Writing",
        text: "0-30",
        id: "5"
      }, {
        name: "Total Score",
        text: "0-120",
        id: "6"
      }],
      scoreLegendsReadingInfo: [{
        name: "Level",
        text: "Scaled Score Range",
        id: "1"
      }, {
        name: "Advanced",
        text: "24-30",
        id: "2"
      }, {
        name: "High-Intermediate",
        text: "18-23",
        id: "3"
      }, {
        name: "Low-Intermediate",
        text: "4-17",
        id: "4"
      }, {
        name: "Below Low-Intermediate",
        text: "0-3",
        id: "5"
      }],
      scoreLegendsListeningInfo: [{
        name: "Level",
        text: "Scaled Score Range",
        id: "1"
      }, {
        name: "Advanced",
        text: "22-30",
        id: "2"
      }, {
        name: "High-Intermediate",
        text: "17-21",
        id: "3"
      }, {
        name: "Low-Intermediate",
        text: "9-16",
        id: "4"
      }, {
        name: "Below Low-Intermediate",
        text: "0-8",
        id: "5"
      }],
      scoreLegendsSpeakingInfo: [{
        name: "Level",
        text: "Scaled Score Range",
        id: "1"
      }, {
        name: "Advanced",
        text: "25-30",
        id: "2"
      }, {
        name: "High-Intermediate",
        text: "20-24",
        id: "3"
      }, {
        name: "Low-Intermediate",
        text: "16-19",
        id: "4"
      }, {
        name: "Basic",
        text: "10-15",
        id: "5"
      }, {
        name: "Below Basic",
        text: "0-9",
        id: "6"
      }],
      scoreLegendsWritingInfo: [{
        name: "Level",
        text: "Scaled Score Range",
        id: "1"
      }, {
        name: "Advanced",
        text: "24-30",
        id: "2"
      }, {
        name: "High-Intermediate",
        text: "17-23",
        id: "3"
      }, {
        name: "Low-Intermediate",
        text: "13-16",
        id: "4"
      }, {
        name: "Basic",
        text: "7-12",
        id: "5"
      }, {
        name: "Below Basic",
        text: "0-6",
        id: "6"
      }],
      DEPTInfo: [{
        name: "DEPT. ",
        text: "WHERE THE REPORT WAS SENT",
        id: "1"
      }, {
        name: "00",
        text: "Admissions office for undergraduate study or an institution or agency that is not a college or university",
        id: "2"
      }, {
        name: "01,04-99",
        text: "Admissions office for graduate study in a field other than management (business) or law according to the codes selected when you registered",
        id: "3"
      }, {
        name: "02",
        text: "Admissions office of a graduate school of management (business)",
        id: "4"
      }, {
        name: "03",
        text: "Admissions office of a graduate school of law",
        id: "5"
      }],
      //                图表
      chartInfoA: [{
        name: '考察部分',
        a1: '正确题数',
        a2: '错误题数',
        a3: '未作答题数 ',
        a4: '题目总数',
        a5: '正确率（ % ）',
        a6: '得分'
      }, {
        name: 'Reading',
        a1: '16',
        a2: '14',
        a3: '0',
        a4: '30',
        a5: '53%',
        a6: '17'
      }, {
        name: 'Listening',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%',
        a6: '19'
      }],
      chartInfoC: [{
        name: '考察部分',
        a1: '正确题数',
        a2: '错误题数',
        a3: '未作答题数 ',
        a4: '题目总数',
        a5: '正确率（ % ）'
      }, {
        name: '新 TPO11_R1_Ancient Egyptian Sculpture- 副本 1 ',
        a1: '16',
        a2: '14',
        a3: '0',
        a4: '30',
        a5: '53%'
      }, {
        name: '新 TPO11_R2_Orientation and Navigation- 副本 1 ',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%'
      }, {
        name: '新 TPO9_R2_Reflection in Teaching ',
        a1: '4',
        a2: '6',
        a3: '0',
        a4: '10%',
        a5: '40'
      }],
      chartInfoD: [{
        name: '考察部分',
        a1: '正确题数',
        a2: '错误题数',
        a3: '未作答题数 ',
        a4: '题目总数',
        a5: '正确率（ % ）'
      }, {
        name: 'TPO11_L1_Conversation- 副本 20',
        a1: '16',
        a2: '14',
        a3: '0',
        a4: '30',
        a5: '53%'
      }, {
        name: 'TPO11_L2_Lecture_20140907- 副本 19',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%'
      }, {
        name: 'TPO11_L4_Conversation- 副本 20 ',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%'
      }, {
        name: 'TPO18_L5_Lecture',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%'
      }, {
        name: 'TPO13_L6_Lecture',
        a1: '20',
        a2: '8',
        a3: '0',
        a4: '28',
        a5: '71%'
      }],
      chartData1: {
        columns: ["Reading", "value"],
        rows: [{
          Reading: "Reading",
          value: 53
        }, {
          Reading: "Listening",
          value: 47
        }]
      },
      chartData2: {
        columns: ["Listening", "value"],
        rows: [{
          Listening: "Listening",
          value: 71
        }, {
          Listening: "Surplus",
          value: 29
        }]
      },
      chartData3: {
        columns: ["name", "得分", "满分"],
        rows: [{
          name: "Speaking",
          得分: 19,
          满分: 11
        }, {
          name: "Writing",
          得分: 18,
          满分: 12
        }]
      },
      chartData4: {
        columns: ["name", "value"],
        rows: [{
          name: "新 TPO11_R1_Ancient Egyptian Sculpture- 副本 1",
          value: 0.5
        }, {
          name: "新 TPO11_R2_Orientation and Navigation- 副本 1",
          value: 0.7
        }, {
          name: "新 TPO9_R2_Reflection in Teaching",
          value: 0.6
        }]
      },
      chartData5: {
        columns: ["name", "value"],
        rows: [{
          name: "TPO13_L6_Lecture",
          value: 0.5
        }, {
          name: "TPO13_L6_Lecture",
          value: 0.7
        }, {
          name: "TPO13_L6_Lecture",
          value: 1
        }, {
          name: "TPO13_L6_Lecture",
          value: 0.2
        }, {
          name: "TPO13_L6_Lecture",
          value: 0.1
        }]
      },
      eInfo: [{
        name: 'TPO11_ 口语 2- 副本18',
        value: '2.5',
        id: '1'
      }, {
        name: 'TPO11_ 口语 2- 副本18',
        value: '2',
        id: '2'
      }, {
        name: 'TPO11_ 口语 2- 副本18',
        value: '5',
        id: '3'
      }, {
        name: 'TPO11_ 口语 2- 副本18',
        value: '4.5',
        id: '4'
      }]
    };
  },
  components: {
    DoExamPaper: DoExamPaper,
    ChartsPage: ChartsPage
  },
  computed: {},
  created: function created() {
    var that = this; //请求地址传递的参数

    var paramsJson = this.$route.query;
    console.log("paramsJson=====================", paramsJson);
    var pageId = 4130;
    var tableId = 311;
    var pageType = 7; //当前数据ID

    var initMainDataId = paramsJson.sepId;

    if (paramsJson.reportType > 0) {
      that.reportType = paramsJson.reportType;
    }

    that.mainDataId = initMainDataId; //列表的tableId

    var mainTableId = 17975;
    var url = "/wxXcxSet_interfaceToAdd.do";
    this.loading = true;
    this.$axios.post(url, {
      pageId: pageId,
      tableId: tableId,
      pageType: pageType,
      mainId: initMainDataId,
      mainTableId: mainTableId
    }).then(function (res) {
      that.loading = false;

      if (res.data) {
        var studentExamPaperInfo = res.data.initUpdateData;
        var chartData3 = that.chartData3;
        studentExamPaperInfo.EPBLOCK_LIST.forEach(function (element, index) {
          if (element.F_4133_AFM_1) {
            element.F_4133_AFM_1 = element.F_4133_AFM_1.replace(/_@/g, "\n");
          }

          if (element.F_4133_AFM_2) {
            element.F_4133_AFM_2 = element.F_4133_AFM_2.replace(/_@/g, "\n");
          }

          if (index < 2) {
            element.chartData = {
              columns: ["Reading", "value"],
              rows: [{
                Reading: element.F_309_BLOCK_NAME,
                value: (element.RIGHT_NUM / element.ALL_NUM * 100).toFixed(0)
              }, {
                Reading: '',
                value: 100 - (element.RIGHT_NUM / element.ALL_NUM * 100).toFixed(0)
              }]
            };
          } else {
            chartData3.rows[index - 2] = {
              name: element.F_309_BLOCK_NAME,
              得分: element.FINAL_SCORE,
              满分: element.ALL_SCORE
            };
          }

          if (index < 2) {
            element.chartData4 = {
              columns: ["name", "value"],
              rows: []
            };
            element.QUESTION_LIST.forEach(function (questionOne, questionIndex) {
              element.chartData4.rows.push({
                name: questionOne.F_307_NAME,
                value: (questionOne.RIGHT_NUM / (questionOne.RIGHT_NUM + questionOne.ERROR_NUM) * 100).toFixed(0)
              });
            });
          } else {
            element.chartData5 = {
              columns: ["name", "得分", "满分"],
              rows: []
            };
            element.QUESTION_LIST.forEach(function (questionOne, questionIndex) {
              element.chartData5.rows.push({
                name: questionOne.F_307_NAME,
                "得分": questionOne.FINAL_SCORE,
                "满分": questionOne.ALL_SCORE
              });
            });
          }

          console.log("chartData4==================", element.chartData4);
        });
        that.chartData3 = chartData3;
        that.studentExamPaperInfo = studentExamPaperInfo;
        console.log("res.data=====================", studentExamPaperInfo);
        that.ifLoad = true;
      }
    }).catch(function (error) {
      console.log("=====" + error);
    });
  },
  mounted: function mounted() {},
  methods: {
    setScroll: function setScroll(top) {
      var that = this;
      this.$nextTick(function () {
        // that.$refs.analysisReport.scrollTo(0,0);
        // $("#app").animate({scrollTop:"0" + "px"}, 0);
        window.scrollTo(0, top);
      });
    },
    toDtkScroll: function toDtkScroll() {
      console.log("5490===================");
      var that = this;
      this.$nextTick(function () {
        // that.$refs.analysisReport.scrollTo(0,0);
        // $("#app").animate({scrollTop:"0" + "px"}, 0);
        setTimeout(function () {
          window.scrollTo(0, 5490);
        }, 2000);
      });
    },
    toImgPrint: function toImgPrint() {
      // 转图片打印
      var that = this;
      that.loadingImage = true;
      html2canvas(this.$refs.print_kw_box, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight
      }).then(function (canvas) {
        that.loadingImage = false; // let url = canvas.toDataURL('image/jpeg', 1.0)

        var url = canvas.toDataURL(); // this.img = url
        // printJS({
        //     printable: url,
        //     type: 'image',
        //     documentTitle: '打印'
        // })

        var a = document.createElement('a'); // 生成一个a元素

        var event = new MouseEvent('click'); // 创建一个单击事件

        a.download = 'photo'; // 设置图片名称

        a.href = url; // 将生成的URL设置为a.href属性

        a.dispatchEvent(event); // 触发a的单击事件

        console.log(url);
      });
    }
  }
};